import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-join-to-pelecrd',
  templateUrl: './join-to-pelecrd.component.html',
  styleUrls: ['./join-to-pelecrd.component.scss']
})
export class JoinToPelecrdComponent implements OnInit {

  

  constructor(
    public dialogRef: MatDialogRef<JoinToPelecrdComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  ngOnInit(): void {
  }

  onClose(event) {

    this.dialogRef.close();
  }

}
